<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h1 class="u">
      Детали банковской транзакции
    </h1>
    <div class="sub-nav">
      <!-- <router-link class="btn btn-default btn-sm" :to="{ name: 'bank-transactions' }">← Назад к Банковским транзакциям</router-link> -->
      <a class="btn btn-default btn-sm" @click="smartBackButton('bank-transactions')">← Назад к Банковским транзакциям</a>
    </div>

    <div class="text-right">
      <a v-if="bank_transaction.id" class="red" href="#" @click.prevent="deleteBankTransaction">удалить банковскую транзакцию</a>
    </div>

    <div class="row">
      <div class="col-md-6">

        <!-- Number -->
        <div class="form-group">
          <label>Номер</label>
          <p>{{ bank_transaction.number }}</p>
        </div>

        <!-- Amount -->
        <div class="form-group">
          <label>Сумма</label>
          <p>{{ toMoney(bank_transaction.amount) }}</p>
        </div>

        <!-- Transaction type -->
        <div class="form-group">
          <label>Тип операции</label>
          <p>{{ bank_transaction.transaction_type }}</p>
        </div>

        <!-- Datetime -->
        <div class="form-group">
          <label>Дата и время</label>
          <p>{{ formatDate(bank_transaction.datetime) }}</p>
        </div>

        <!-- Purpose -->
        <div class="form-group">
          <label>Назначение</label>
          <p>{{ bank_transaction.purpose }}</p>
        </div>

        <!-- Recognized -->
        <div class="form-group">
          <label>Распознана</label>
          <p>{{ bank_transaction.recognized }}</p>
        </div>

      </div>
    </div>

    <div class="row" v-if="!bank_transaction.recognized">
      <div class="col-md-12">
        <h1>Подвязать к клиенту</h1>
        <div>
          <select-client @selectClient="bindToClient" />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { getBankTransaction, deleteBankTransaction, bindToClient } from '@/services/bank_transaction.service'
import selectClient from '@/components/lists/client/SelectClient'
import helpers from '@/helpers'

export default {
  name: 'bank-transaction-details',
  components: { selectClient },
  data () {
    return {
      bank_transaction: {
        id: null,
        amount: '',
        transaction_type: '',
        datetime: '',
        purpose: '',
        number: '',
        recognized: ''
      }
    }
  },
  mounted () {
    if (this.$route.params.bank_transaction_id !== undefined) {
      this.bank_transaction.id = this.$route.params.bank_transaction_id

      getBankTransaction(this.bank_transaction.id).then((response) => {
        this.bank_transaction = response.data
      })
    }
  },
  methods: {
    smartBackButton: helpers.smartBackButton,
    formatDate: helpers.formatDate,
    toMoney: helpers.toMoney,

    deleteBankTransaction () {
      deleteBankTransaction(this.bank_transaction.id).then((response) => {
        this.showMsg('Банковская транзакция была удалена!', 'success', 'Успешно')
        this.$router.push({ name: 'bank-transactions' })
        return true
      }).catch(err => {
        console.log(err)
        this.showMsg('Транзакция была удалена!', 'success', 'Успешно')
        this.$router.push({ name: 'bank-transactions' })
        return true
      })
    },
    bindToClient (clientId) {
      bindToClient(this.bank_transaction.id, clientId).then((response) => {
        getBankTransaction(this.bank_transaction.id).then((response2) => {
          this.bank_transaction = response2.data
        })

        this.showMsg('Транзакция была подвязана к клиенту!')
      }).catch(err => {
        console.log(err)
        this.showMsg('Ошибка!')
      })
    },
    showMsg (text, type, title) {
      let foundRoot = false
      let $parent = this.$parent

      while (!foundRoot) {
        console.log($parent)
        if ($parent.$parent.$parent === undefined) {
          foundRoot = true
          $parent.showPopupMsg(text, type, title)
        } else {
          $parent = $parent.$parent
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// BankTransactionDetails.vue?4bf7886e